import {
  Grid,
  Box,
  Typography,
  IconButton,
  Popover,
  Button
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface LogoNavigatorProps {
  onReset: () => void;
}

const LogoNavigator = ({ onReset }: LogoNavigatorProps) => {
  const logoRef = useRef<HTMLElement>(null);
  const [navigatorOpen, setNavigatorOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setNavigatorOpen(false);
  }, [pathname]);

  return (
    <Grid item xs={4}>
      <Box
        width={250}
        display={'flex'}
        sx={{ cursor: 'pointer' }}
        ref={logoRef}
      >
        <Typography variant="h4" onClick={onReset}>
          {EnumToString(pathname.replace('/', '') as RoutePathType)}
        </Typography>
        <IconButton
          onClick={() => {
            setNavigatorOpen((prev) => !prev);
          }}
        >
          <ArrowDropDownIcon />
        </IconButton>
      </Box>
      <Popover
        open={navigatorOpen}
        anchorEl={logoRef.current}
        onClose={() => setNavigatorOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Grid container width={200}>
          {Object.keys(RoutePathType).map((path) => (
            <NaviButton key={path} location={path as RoutePathType} />
          ))}
        </Grid>
      </Popover>
    </Grid>
  );
};

export default LogoNavigator;

interface NaviButtonProps {
  location: RoutePathType;
}

const NaviButton = ({ location }: NaviButtonProps) => {
  const navigate = useNavigate();
  const { pathname: currentPath } = useLocation();

  const disabled = currentPath.includes(location);

  return (
    <Grid item xs={12} bgcolor={disabled ? 'gray' : 'none'}>
      <Button
        fullWidth
        onClick={() => navigate(`/${location}`)}
        disabled={disabled}
      >
        <Typography variant="h5" color={'textSecondary'}>
          {EnumToString(location)}
        </Typography>
      </Button>
    </Grid>
  );
};

enum RoutePathType {
  industry = 'industry',
  factoryon = 'factoryon',
  innobiz = 'innobiz',
  mainbiz = 'mainbiz',
  venture = 'venture',
  miniCluster = 'miniCluster'
}

const EnumToString = (path?: RoutePathType) => {
  switch (path) {
    case 'industry':
      return '산업단지 DB';
    case 'factoryon':
      return '팩토리온';
    case 'innobiz':
      return '이노비즈 DB';
    case 'mainbiz':
      return '메인비즈 협회';
    case 'venture':
      return '벤처기업 협회';
    case 'miniCluster':
      return '미니 클러스터';
    default:
      '??';
  }
};
